module.exports = __webpack_public_path__ + "img/img10.e8ace2dd.jpg";